// extracted by mini-css-extract-plugin
module.exports = {"SampleSection":"Sample_SampleSection__XwmlJ","SampleIntro":"Sample_SampleIntro__Yn9GX","imgWrap":"Sample_imgWrap___gBBg","SampleLink":"Sample_SampleLink__yGSY2"};